export default __webpack_public_path__ + "static/media/almaz_mangisto.f3396d95.png";